export const mergeStyles = (styles: Record<string, unknown>[]) => {
  /**
   * Styled system uses `any` as the return type, so we will too.
   */
  const output: any = {}

  for (const style of styles) {
    for (const [property, value] of Object.entries(style)) {
      if (property.startsWith('@media')) {
        if (value instanceof Object) {
          output[property] ??= {}
          Object.assign(output[property]!, value)
        }
      } else {
        output[property] = style[property]
      }
    }
  }

  return output
}
